import { create } from 'zustand';

type WalletType = 'Solflare' | 'Backpack' | 'MagicEden';
type ModalContext = 'connect' | 'setPrimary' | 'mint' | 'upgrade' | 'claim';

interface MobileWalletNavState {
  visible: boolean;
  walletType: WalletType | null;
  context: ModalContext | null;
  onChangePrimary: (() => void) | undefined;
  showModal: (walletType: WalletType, context: ModalContext, onChangePrimary?: () => void) => void;
  hideModal: () => void;
}

const useMobileWalletNavStore = create<MobileWalletNavState>((set) => ({
  visible: false,
  walletType: null,
  context: null,
  onChangePrimary: undefined,
  showModal: (walletType, context, onChangePrimary) =>
    set({ visible: true, walletType, context, onChangePrimary }),
  hideModal: () =>
    set({ visible: false, walletType: null, context: null, onChangePrimary: undefined }),
}));

export default useMobileWalletNavStore;
